<div class="header-helper">Please select the type(s) of RZMS-related email communications that you'd like to receive from IANA:</div>
<div class="content-with-elevation content communication-settings">

    <form [formGroup]="communicationsForm" (ngSubmit)="onSubmit()" novalidate>
        <label class="labelRZM" for="operation-control">
            <input formControlName="operation" id="operation-control" type="checkbox" />
            Operational Updates
        </label>
        <p>Critical communications about IANA office closures and other changes to our service offerings</p>
        <label for="product-control" class="labelRZM">
            <input formControlName="product" (click)="modified = true" id="product-control" type="checkbox" />
            Product Announcements
        </label>
        <p>Includes release notes and other notifications related to specific RZMS features</p>
        <label for="security-control" class="labelRZM">
            <input formControlName="security" (click)="modified = true" id="security-control" type="checkbox" />
            Security Reminders
        </label>
        <p>User-specific suggestions regarding security best practices</p>

        <div class="grid-x  align-end" *ngIf="!isStaffUI">
            <div class="save-cancel-button-group ">
                <button class="iana-button"  type="submit"
                        [disabled]="!modified">{{modified ? 'Save' : 'Saved'}}
                </button>
                <button class="iana-button-cancel" type="reset" *ngIf="modified" (click)="cancel()">Cancel</button>
            </div>
        </div>
    </form>
</div>
